import * as React from "react";

import { Modal } from "@replo/design-system/components/modal/Modal";
import { AddDomainForm } from "@v2/features/settings/shop/domains/AddDomainForm";
import { getProjectLabels } from "@v2/utils/project-labels";

interface AddDomainModalProps {
  projectId: string;
  shopDomainPrefix: string;
  isEntriModalInProgress: boolean;
}

/**
 * Modal that will open when +Add Domain is pressed
 */
export const AddDomainModal: React.FC<
  AddDomainModalProps & {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }
> = ({
  projectId,
  shopDomainPrefix,
  isEntriModalInProgress,
  open,
  onOpenChange,
}) => {
  const labels = getProjectLabels("replo");

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title="Add Domain"
      description={`Connect a custom domain to your ${labels.singular}`}
      size="base"
    >
      <div className="flex flex-col gap-3 w-full">
        <AddDomainForm
          projectId={projectId}
          shopDomainPrefix={shopDomainPrefix}
          showCancelButton={false}
          isEntriModalInProgress={isEntriModalInProgress}
        />
      </div>
    </Modal>
  );
};
